const documentsStatus = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "inactive",
    label: "Inactive",
  },
  {
    value: "updated",
    label: "Updated",
  },
  {
    value: "expired",
    label: "Expired",
  },
  {
    value: "terminated",
    label: "Terminated",
  },
];

const agreeMentsStatusFilters = [
  { ...documentsStatus[0] },
  { ...documentsStatus[3] },
  { ...documentsStatus[4] },
];

const productsAndOtherStatusFilters = [
  { ...documentsStatus[0] },
  { ...documentsStatus[1] },
  { ...documentsStatus[2] },
];

export {
  agreeMentsStatusFilters,
  productsAndOtherStatusFilters,
  documentsStatus,
};
